import { Card, Form, Button, Row } from "react-bootstrap";
import Table from "../../Components/UI/Table/Table";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../utils/types";
import { useEffect, useState } from "react";
import { GetBidsAction } from "../../Redux/Actions/CBidActions";
import "./style.css";
import * as yup from "yup";
import {
  useFormik,
} from "formik";
import { convertUtcToLocal } from "../../utils/functions";
import Spinner from "../../Components/UI/Spinner/Spinner";
import CsvDownloader from "react-csv-downloader";
import { CBidCommonColumns, CBidAdminColumns } from './CBidConstant';
import HashModal, { HashButton } from "../Admin/HashModal";
import moment from "moment";
import FeatherIcon from "feather-icons-react";

const BidRequests = () => {
  const dispatch = useDispatch();
  const BidRequestsState = useSelector((state: IReduxState) => state.BidRequests);

  const adminState = useSelector((state: IReduxState) => state.Auth);
  const [showHashModal, setShowHashModal] = useState(false);
  const [tableData, setTableData] = useState<any[]>([]);
  const handleCloseModal = () => setShowHashModal(false);


  const CBidDataTable = BidRequestsState.bids.map((item: any) => {
    const fixedItem: any = {};
    for (const prop in item) {
      fixedItem[prop] = item[prop]
        ? item[prop].includes(",")
          ? `"${item[prop]}"`
          : item[prop]
        : "";
    }

    return {
      ...fixedItem,
      REQUEST_TIME: convertUtcToLocal(item.REQUEST_TIME, "DD/MM/YYYY HH:mm:ss"),
      USER_ID: item.USER_ID
        ? item.USER_ID.split(".").length > 1
          ? item.USER_ID.split(".")[1]
          : item.USER_ID.split(".")[0]
        : "",
    };
  });

  const formik: any = useFormik({
    initialValues: {
      hour: "",
      userId: "",
      appBundle: "",
      ipAddress: "",
      ipv6: "",
      url: "",
      csv: false,
    },

    validationSchema: yup.object().shape(
      {
        ipAddress: yup
          .string()
          .ensure()
          .when("userId", {
            is: "",
            then: yup
              .string()
              .ensure()
              .when("ipv6", {
                is: "",
                then: yup
                  .string()
                  .ensure()
                  .when("appBundle", {
                    is: "",
                    then: yup
                      .string()
                      .ensure()
                      .when("url", {
                        is: "",
                        then: yup
                          .string()
                          .required(
                            "Either IP, User ID, App Bundle or URL is required"
                          )
                          .matches(
                            /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i,
                            "Please use IPv4 address format (X.X.X.X)"
                          ),
                      }),
                  }),
              }),
            //otherwise: yup.string()
          }),
        ipv6: yup
          .string()
          .ensure()
          .when("userId", {
            is: "",
            then: yup
              .string()
              .ensure()
              .when("ipAddress", {
                is: "",
                then: yup
                  .string()
                  .ensure()
                  .when("appBundle", {
                    is: "",
                    then: yup
                      .string()
                      .ensure()
                      .when("url", {
                        is: "",
                        then: yup
                          .string()
                          .required(
                            "Either IP, User ID, App Bundle or URL is required"
                          )
                          .matches(
                            /^([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]?)$/i,
                            "Please use IPv6 address format (x:x:x:x:x:x:x:x)"
                          ),
                      }),
                  }),
              }),
            //otherwise: yup.string()
          }),
        userId: yup
          .string()
          .ensure()
          .when("appBundle", {
            is: "",
            then: yup
              .string()
              .ensure()
              .when("ipAddress", {
                is: "",
                then: yup
                  .string()
                  .ensure()
                  .when("ipv6", {
                    is: "",
                    then: yup
                      .string()
                      .ensure()
                      .when("url", {
                        is: "",
                        then: yup
                          .string()
                          .required(
                            "Either IP, User ID, App Bundle or URL is required"
                          ),
                      }),
                  }),
              }),
            // otherwise: yup.string()
          }),
        appBundle: yup
          .string()
          .ensure()
          .when("userId", {
            is: "",
            then: yup
              .string()
              .ensure()
              .when("ipAddress", {
                is: "",
                then: yup
                  .string()
                  .ensure()
                  .when("ipv6", {
                    is: "",
                    then: yup
                      .string()
                      .ensure()
                      .when("url", {
                        is: "",
                        then: yup
                          .string()
                          .required(
                            "Either IP, User ID, App Bundle or URL is required"
                          ),
                      }),
                    // otherwise: yup.string()
                  }),
              }),
            // otherwise: yup.string()
          }),

        url: yup
          .string()
          .ensure()
          .when("userId", {
            is: "",
            then: yup
              .string()
              .ensure()
              .when("appBundle", {
                is: "",
                then: yup
                  .string()
                  .ensure()
                  .when("ipv6", {
                    is: "",
                    then: yup
                      .string()
                      .ensure()
                      .when("ipAddress", {
                        is: "",
                        then: yup
                          .string()
                          .required(
                            "Either IP, User ID, App Bundle or URL is required"
                          ),
                      }),
                  }),
              }),
          }),
      },
      [
        ["userId", "ipAddress"],
        ["userId", "appBundle"],
        ["userid", "ipv6"],
      ]
    ),

    onSubmit: (value, { resetForm }) => {
      if (value.csv) {
        //dispatch(exportCBIDDataAction(value.hour,value.userId,value.appBundle,value.ipAddress,value.ipv6,value.url));
      } else {
        setTableData([]);
        dispatch(
          GetBidsAction(
            value.hour,
            value.userId,
            value.appBundle,
            value.ipAddress,
            value.ipv6,
            value.url
          )
        );
      }
      value.csv = false;
    },
  });

  useEffect(() => {
    return () => {
    dispatch(GetBidsAction(null, "", "", "", "", ""));
    };
  }, []);
  const sizePerPageList = [
    {
      text: "10",
      value: 10,
    },
    {
      text: "25",
      value: 25,
    },
    {
      text: "50",
      value: 50,
    },
  ];
  let columns: any = [];

  if (adminState.role.includes("admin")) {
    columns = CBidAdminColumns;
  } else {
    columns = CBidCommonColumns;
  }

  let newColumns = columns.map((column: any) => ({
    id: column.Header,
    displayName: column.Header,
  }));
  

  useEffect(() => {
    if (BidRequestsState?.bids?.length) {
      const sortedData = [...BidRequestsState.bids].sort((a: any, b: any) => {
        const dateA = moment(a.REQUEST_TIME, "DD/MM/YYYY HH:mm:ss", true).toDate();
        const dateB = moment(b.REQUEST_TIME, "DD/MM/YYYY HH:mm:ss", true).toDate();

        return dateA.getTime() - dateB.getTime();
      });

      setTableData(sortedData);
    }
  }, [BidRequestsState.bids]);

  return (
    <>
    {showHashModal && <HashModal showHashModal={showHashModal} onClose={handleCloseModal}/>}
      <Row className="d-flex justify-content-center mt-3">
        <Row>
          <h3 className="module_title" style={{marginBottom: '0px'}}>Bid Requests<p>Viewing recent Ad bid requests for a specific IP or ADID</p></h3>
        </Row>
      </Row>
      <Card>
        <Card.Body>
          <div className="expertFilter">
            <div className="expertFilterFields">
              <div>
                <Form.Label
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                  className="noMargin"
                >
                  Hour Range:
                </Form.Label>
                <Form.Select
                  name="hour"
                  value={formik.values.hour}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="fsz-875rem "
                >
                  <option value="1">Last Hour</option>
                  <option value="2">Last 2 Hours</option>
                  <option value="3">Last 3 Hours</option>
                  {/* <option value="5">Last 5 Hours</option> */}
                  <option value="24">Last 24 Hours</option>
                  <option value="48">Last 48 Hours</option>
                  <option value="72">Last 72 Hours</option>
                  {/* <option value="336">Last 2 Weeks</option> */}
                  
                </Form.Select>
              </div>
              <div className="position-relative">
                <Form.Label
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                  className="noMargin"
                >
                  User ID
                </Form.Label>

                <Form.Control
                  id="example-date"
                  type="text"
                  name="userId"
                  className="fsz-875rem"
                  value={formik.values.userId}
                  onChange={formik.handleChange}
                  isInvalid={!!formik.errors?.userId}
                />
              </div>
              <div className="position-relative">
                <Form.Label
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                  className="noMargin"
                >
                  App Bundle
                </Form.Label>

                <Form.Control
                  id="example-date"
                  type="text"
                  name="appBundle"
                  className="fsz-875rem"
                  value={formik.values.appBundle}
                  onChange={formik.handleChange}
                  isInvalid={!!formik.errors?.appBundle}
                />
              </div>
              <div className="position-relative">
                <Form.Label
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                  className="noMargin"
                >
                  IPv4 Address
                </Form.Label>

                <Form.Control
                  id="example-date"
                  type="text"
                  name="ipAddress"
                  className="fsz-875rem"
                  value={formik.values.ipAddress}
                  onChange={formik.handleChange}
                  isInvalid={!!formik.errors?.ipAddress}
                />
              </div>
              <div className="position-relative">
                <Form.Label
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                  className="noMargin"
                >
                  IPv6 Address
                </Form.Label>

                <Form.Control
                  id="example-date"
                  type="text"
                  name="ipv6"
                  className="fsz-875rem"
                  value={formik.values.ipv6}
                  onChange={formik.handleChange}
                  isInvalid={!!formik.errors?.ipv6}
                />
              </div>
              <div className="position-relative">
                <Form.Label
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                  className="noMargin"
                >
                  URL
                </Form.Label>

                <Form.Control
                  id="example-date"
                  type="text"
                  name="url"
                  className="fsz-875rem"
                  value={formik.values.url}
                  onChange={formik.handleChange}
                  isInvalid={!!formik.errors?.url}
                />
              </div>
              <div className="btngrp">
                <Button
                  className="noMargin"
                  onClick={() => {
                    formik.handleSubmit();
                  }}
                  variant="success"
                >
                  Apply
                </Button>

                <Button
                  onClick={() => {
                    formik.resetForm({
                      values: {
                        hour: "",
                        userId: "",
                        appBundle: "",
                        ipAddress: "",
                        ipv6: "",
                        url: "",
                      },
                    });
                  }}
                  className="noMargin"
                  variant="secondary"
                >
                  Clear
                </Button>
              </div>
            </div>
            <div className="expertFilterFields">
              {adminState.show_hash &&
            // <Button
            //                   className="mb-0 mr-2 orange-btn"
            //                   variant="warning"
            //                   onClick={() => {
            //                     setShowHashModal(true);
            //                   }}
            //                 >
            //                   <FeatherIcon icon='hash' size={17} style={{ verticalAlign: 'sub'}}/> User ID{" "}
            //                 </Button>
            <HashButton onClick={() => {setShowHashModal(true)}} className={'mb-0 mr-2 orange-btn'}/>
}
            <CsvDownloader
              datas={CBidDataTable}
              columns={newColumns}
              text="Export to CSV"
              filename={`bid_requests_` + new Date().toLocaleString()}
              extension=".csv"
              className="btn btn-primary ExportBtn no-margin"
            />
            </div>
          </div>
          <div className="position-relative">
            {formik.errors.userId ? (
              <span
                style={{
                  color: "#dc3545",
                  fontFamily: "Silka",
                  fontSize: 12,
                }}
              >
                {formik.errors.userId}
              </span>
            ) : formik.errors?.ipAddress ? (
              <span
                style={{
                  color: "#dc3545",
                  fontFamily: "Silka",
                  fontSize: 12,
                }}
              >
                {formik.errors?.ipAddress}
              </span>
            ) : formik.errors?.ipv6 ? (
              <span
                style={{
                  color: "#dc3545",
                  fontFamily: "Silka",
                  fontSize: 12,
                }}
              >
                {formik.errors?.ipv6}
              </span>
            ) : formik.errors?.appBundle ? (
              <span
                style={{
                  color: "#dc3545",
                  fontFamily: "Silka",
                  fontSize: 12,
                }}
              >
                {formik.errors?.appBundle}
              </span>
            ) : formik.errors?.url ? (
              <span
                style={{
                  color: "#dc3545",
                  fontFamily: "Silka",
                  fontSize: 12,
                }}
              >
                {formik.errors?.url}
              </span>
            ) : null}
          </div>

          {BidRequestsState.loading && (
            <div className="popUpUser">
              <Spinner className="m-2" color={"primary"}></Spinner>
            </div>
          )}
          <Table
            columns={columns}
            data={tableData}
            pageSize={10}
            sizePerPageList={sizePerPageList}
            isSortable={false}
            pagination={true}
            isSearchable={false}
          />
        </Card.Body>
      </Card>
    </>
  );
};

export default BidRequests;
